export class TransferSearchRequestDTO {
  constructor() {
    this.search_string = null;
    this.guild_id = null;
  }
}